module.exports = __webpack_public_path__ + "img/measurement_info_back_shoulder_left_animated.7c6d9cf4.gif";